import React from 'react';
import PropTypes from 'prop-types';
import { ChevronRightIcon } from '@domain-group/fe-co-icon';
import * as styles from './empty-state.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var PropertyHistoryEmptyState = props => ___EmotionJSX("div", {
  css: styles.emptyState
}, ___EmotionJSX("div", {
  css: styles.text
}, "We couldn't find any history for this property."), props.suburbLink && props.suburbName && ___EmotionJSX("a", {
  href: props.suburbLink
}, ___EmotionJSX("div", {
  css: styles.linkText
}, "See ", props.suburbName, "'s suburb profile"), ___EmotionJSX(ChevronRightIcon, {
  size: "small",
  css: styles.linkIcon
})));
PropertyHistoryEmptyState.propTypes = {
  suburbName: PropTypes.string,
  suburbLink: PropTypes.string
};
PropertyHistoryEmptyState.defaultProps = {
  suburbLink: null,
  suburbName: null
};
export default PropertyHistoryEmptyState;